import moment from "moment";

function cc_format(value) {
  if (value) {
    var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    var matches = v.match(/\d{4,16}/g);
    var match = (matches && matches[0]) || "";
    var parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
      return parts.join("-");
    } else {
      return value;
    }
  }
}

export default {
  formatDate(value, format) {
    // console.log("format date", value, " in format ", format);
    if (value) {
      if (typeof value == "string") {
        return moment(String(value)).format(format);
      } else if (typeof value == "object") {
        if (value && value.val == "CURRENT_TIMESTAMP") {
          let now = moment();
          return format ? now.format(format) : now.format();
        } else return "?";
      }
    }
  },
  sizeFromKB(value) {
    let kB = (value / 1024).toFixed(2);
    let mB = (kB / 1024).toFixed(2);
    if (kB < 1000) return kB + " Kb";
    else if (mB < 1000) return mB + " Mb";
    else return "?";
  },
  fromNow(value, no_suffix = false) {
    return moment(value).fromNow(no_suffix);
  },
  formatCurrency(value, currency) {
    if (value || value == 0) {
      const formatter = new Intl.NumberFormat("es-GT", {
        style: "currency",
        currency: currency || "GTQ",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    }
  },
  formatVisaCurrency(value) {
    if (value) {
      let integers = value.substring(0, value.length - 2);
      let decimals = value.substring(value.length - 2);
      return `Q ${integers}.${decimals}`;
    } else return "";
  },
  creditCard(value) {
    if (value) {
      let formatted = cc_format(value);
      return formatted;
    }
  },
  hiddenCreditCard(value) {
    if (value) {
      let formatted = cc_format(value);
      let last = formatted.substr(-4);
      return `XXXX - XXXX - XXXX - ${last}`;
    }
  },
  truncate(data, num) {
    const reqdString = data
      .split("")
      .slice(0, num)
      .join("");
    return reqdString + "...";
  },
};
